
import admin from './admin'
import vehicle from './vehicle';
import driverGuide from './driver-guide'
import guest from './guest';
import vendor from './vendor';
import destination from './destination';
import accommodation from './accommodation';
import transportation from './transportation';
import activity from './activity';
import program from './program';
import packages from './package';
import spj from './spj';
import offerDoc from './offer-document';
import test from './test'
import maintenance from './maintenance';

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import("@/views/HomeView.vue")
        
    },
    ...admin,
    ...driverGuide,
    ...guest,
    ...vendor,
    ...test,
    ...vehicle,
    ...destination,
    ...transportation,
    ...activity,
    ...accommodation,
    ...program,
    ...packages,
    ...spj,
    ...offerDoc,
    ...maintenance    

]
export default routes;
